

import React, { useState, useRef, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { makeStyles } from '@material-ui/core/styles';
import { 
  Button, 
  Container, 
  Typography, 
  IconButton,
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableRow,
  Box,
  TextField  
} from '@material-ui/core';
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import FormatItalicIcon from '@material-ui/icons/FormatItalic';
import FormatUnderlinedIcon from '@material-ui/icons/FormatUnderlined';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import SaveIcon from '@material-ui/icons/Save';
import PrintIcon from '@material-ui/icons/Print';
import { useDispatch } from 'react-redux';
import { patientActions } from '../../core/actions';
import { RADIOLOGYREPORT } from '../../shared/constants';
import { useOrganization } from '../../configurations/OrganizationContext';
import Components from '..';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '90vh',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
    position: 'relative',
    overflow: 'auto',
  },
  header: {
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    color: theme.palette.primary.main,
  },
  formatToolbar: {
    marginBottom: theme.spacing(2),
    border: '1px solid #ddd',
    borderRadius: '4px',
    padding: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(1),
    backgroundColor: '#fff',
    '& .active': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
  contentSection: {
    marginBottom: theme.spacing(2),
    '& .ql-container': {
      fontSize: '14px',
      border: 'none',
      '& .ql-editor': {
        minHeight: '60px',
        padding: '8px',
      },
    },
    '& .ql-toolbar': {
      display: 'none',
    },
  },
  table: {
    border: '2px solid #000',
    borderCollapse: 'collapse',
    width: '100%',
    '& th, & td': {
      border: '1px solid #000',
      padding: '8px',
      verticalAlign: 'top',
      fontSize: '14px',
    },
    '& th': {
      backgroundColor: '#f5f5f5',
      fontWeight: 'bold',
      textAlign: 'center',
      fontSize: '0.9rem',
      cursor: 'pointer',
      height: '60px',
    },
    '& td': {
      height: '80px',
      '& .ql-container': {
        border: 'none',
        fontSize: '14px',
        '& .ql-editor': {
          padding: '8px',
          minHeight: '60px',
        },
      },
      '& .ql-toolbar': {
        display: 'none',
      },
    },
  },
  headerEditField: {
    '& .MuiInputBase-input': {
      fontSize: '0.9rem',
      fontWeight: 'bold',
      textAlign: 'center',
      padding: '8px',
      backgroundColor: '#fff',
    },
  },
  buttonContainer: {
    textAlign: 'center',
    marginTop: theme.spacing(3),
  },
  sectionTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    fontSize: '1rem',
  },
  doctorInfoContainer: {
    marginTop: theme.spacing(3),
    '& .ql-container': {
      border: 'none',
      fontFamily: theme.typography.fontFamily,
      fontSize: '1rem',
      lineHeight: '1.5',
    },
    '& .ql-editor': {
      // textAlign: 'center',
      padding: theme.spacing(1),
    },
  },
}));

const Follicular = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const org = useOrganization();
  const [editingHeader, setEditingHeader] = useState(null);
  const quillRefs = useRef({});
  const [activeQuill, setActiveQuill] = useState(null);
  const [printData, setPrintData] = useState(null);
const [currentFormats, setCurrentFormats] = useState({});
const [tableData, setTableData] = useState([]);
  // Editable headers
  const [headers, setHeaders] = useState([
    { id: 'date', text: 'DATE' },
    { id: 'day', text: 'DAY' },
    { id: 'rightOvary', text: 'RIGHT OVARY' },
    { id: 'leftOvary', text: 'LEFT OVARY' },
    { id: 'endometrialThickness', text: 'ENDOMETRIAL THICKNESS' },
    { id: 'pouchOfDouglas', text: 'POUCH OF DOUGLAS' },
  ]);

  // Content above and below table
  // Content above and below table
// const [contentAboveTable, setContentAboveTable] = useState('Uterus : ');
const [uterus, setUterus] = useState('Uterus : ');
const [lmp, setLmp] = useState('LMP : ');
const [contentBelowTable, setContentBelowTable] = useState('Impression : ');


  // Doctor information
  const [doctorInfo, setDoctorInfo] = useState(
    `<p><strong>${org?.isRadiology?.Doctor || ''}</strong></p>
<p><strong>${org?.isRadiology?.Qualification || ''}</strong></p>
<p><strong>${org?.isRadiology?.RegNo || ''}</strong></p>`
  );

  // const [tableData, setTableData] = useState(
  //   Array(4).fill(null).map((_, index) => ({
  //     id: index,
  //     date: '',
  //     day: '',
  //     rightOvary: '',
  //     leftOvary: '',
  //     endometrialThickness: '',
  //     pouchOfDouglas: ''
  //   }))
  // );

  // Toolbar modules configuration
  const modules = {
    toolbar: false,
    clipboard: { matchVisual: false }
  };

  const formats = ['bold', 'italic', 'underline', 'list', 'bullet'];

  // Convert to HTML function
  const convertToHTML = () => {
    return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Follicular Study Cycle Report</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      line-height: 1.6;
      margin: 20px;
      white-space: pre-wrap;
    }
    .follicular-study-report {
      max-width: 1000px;
      margin: 0 auto;
    }
    h2 {
      text-align: center;
      margin-bottom: 20px;
    }
    .main-table {
      width: 100%;
      border-collapse: collapse;
      border: 2px solid #000;
      margin: 20px 0;
    }
    .main-table th, .main-table td {
      border: 1px solid #000;
      padding: 8px;
    }
    .main-table th {
      background-color: #f5f5f5;
      font-weight: bold;
      text-align: center;
    }
    .content-above-table, .content-below-table {
      margin: 15px 0;
      white-space: pre-wrap;
    }
    .doctor-info {
      text-align: center;
      margin-top: 30px;
      margin-bottom: 20px;
      font-size: 1rem;
      line-height: 1.5;
    }
    .doctor-info p {
      margin-bottom: 8px;
    }
  </style>
</head>
<body>
  <div class="follicular-study-report">
    <h2>FOLLICULAR STUDY CYCLE</h2>
    <div class="content-above-table" style="display:flex; gap:40px;">
  <div>${(uterus || '').replace(/  /g, '&nbsp;&nbsp;')}</div>
  <div>${(lmp || '').replace(/  /g, '&nbsp;&nbsp;')}</div>
</div>
    <table class="main-table">
      <thead>
        <tr>
          ${headers.map(header =>
      `<th>${header.text}</th>`
    ).join('')}
        </tr>
      </thead>
      <tbody>
        ${tableData.map(row =>
      `<tr>
            ${headers.map(header =>
        `<td>${row[header.id] || ''}</td>`
      ).join('')}
          </tr>`
    ).join('')}
      </tbody>
    </table>
    
    <div class="content-below-table">
      ${(contentBelowTable || '').replace(/  /g, '&nbsp;&nbsp;')}
    </div>
    
    <div class="doctor-info">
      ${doctorInfo.replace(/  /g, '&nbsp;&nbsp;')}
    </div>
  </div>
</body>
</html>`;
  };


const parseHTMLContent = (htmlString) => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
const aboveDivs = doc.querySelectorAll('.content-above-table > div');

const extractedUterus = aboveDivs[0]?.innerHTML || 'Uterus : ';
const extractedLmp = aboveDivs[1]?.innerHTML || 'LMP : ';

    const contentBelowElement = doc.querySelector('.content-below-table');
    const contentBelow = contentBelowElement ? contentBelowElement.innerHTML : '';

    const doctorElement = doc.querySelector('.doctor-info');
    const extractedDoctorInfo = doctorElement ? doctorElement.innerHTML :
      `<p><strong>${org?.isRadiology?.Doctor || ''}</strong></p>
<p><strong>${org?.isRadiology?.Qualification || ''}</strong></p>
<p><strong>${org?.isRadiology?.RegNo || ''}</strong></p>`;

    const headerElements = doc.querySelectorAll('thead th');
    const extractedHeaders = Array.from(headerElements).map((th, index) => ({
      id: ['date', 'day', 'rightOvary', 'leftOvary', 'endometrialThickness', 'pouchOfDouglas'][index] || `col${index}`,
      text: th.textContent.trim()
    }));

    const bodyRows = doc.querySelectorAll('tbody tr');
    const extractedTableData = Array.from(bodyRows).map((row, rowIndex) => {
      const cells = row.querySelectorAll('td');
      const rowData = { id: rowIndex };

      cells.forEach((cell, cellIndex) => {
        const headerId = extractedHeaders[cellIndex]?.id || `col${cellIndex}`;
        // Get full HTML content from the cell
        rowData[headerId] = cell.innerHTML || '';
      });

      return rowData;
    });

    console.log("✅ Successfully parsed HTML data:");
    console.log("  - Headers:", extractedHeaders);
    console.log("  - Table rows:", extractedTableData.length);
    console.log("  - Sample row data:", extractedTableData[0]);

    return {
  headers: extractedHeaders,
  tableData: extractedTableData,
  uterus: extractedUterus,
  lmp: extractedLmp,
  contentBelowTable: contentBelow,
  doctorInfo: extractedDoctorInfo
};
  } catch (error) {
    console.error('❌ Error parsing HTML content:', error);
    return null;
  }
};

useEffect(() => {
  console.log("🔄 Follicular useEffect triggered");
  console.log("  - selectedProcedure exists:", !!props.selectedProcedure);
  console.log("  - longdesc exists:", !!props.selectedProcedure?.longdesc);

  if (props.selectedProcedure?.longdesc) {
    const longdesc = props.selectedProcedure.longdesc;
    console.log("  - longdesc length:", longdesc.length);
    console.log("  - longdesc preview:", longdesc.substring(0, 100));

    if (longdesc.trim().startsWith('<') && longdesc.includes('</')) {
      // Parse HTML content
      console.log("  - Parsing as HTML");
      const parsedData = parseHTMLContent(longdesc);
      
      if (parsedData) {
        // CRITICAL: Batch all state updates together
        console.log("  - Applying parsed data to state");
        
        setHeaders(parsedData.headers);
        setUterus(parsedData.uterus);
setLmp(parsedData.lmp);
        setContentBelowTable(parsedData.contentBelowTable);
        setDoctorInfo(parsedData.doctorInfo);
        
        // Set table data LAST and with validation
        if (parsedData.tableData && parsedData.tableData.length > 0) {
          console.log("  ✅ Setting table data with", parsedData.tableData.length, "rows");
          setTableData(parsedData.tableData);
        } else {
          console.log("  ⚠️ No table data found, using default empty rows");
          setTableData(
            Array(4).fill(null).map((_, index) => ({
              id: index,
              date: '',
              day: '',
              rightOvary: '',
              leftOvary: '',
              endometrialThickness: '',
              pouchOfDouglas: ''
            }))
          );
        }
      }
    } else {
      // Try to parse as JSON (for backward compatibility)
     // Try to parse as JSON (for backward compatibility)
try {
  console.log("  - Parsing as JSON");
  let parsedData = JSON.parse(longdesc);
  console.log("  - JSON parsed successfully");

  if (parsedData.headers) {
    setHeaders(parsedData.headers);
  }

  // ✅ OLD DATA SUPPORT
  if (parsedData.contentAboveTable !== undefined) {
    setUterus(parsedData.contentAboveTable);
    setLmp('LMP : ');
  }

  // ✅ NEW DATA SUPPORT (if later you store uterus/lmp separately)
  if (parsedData.uterus !== undefined) {
    setUterus(parsedData.uterus);
  }
  if (parsedData.lmp !== undefined) {
    setLmp(parsedData.lmp);
  }

  if (parsedData.contentBelowTable !== undefined) {
    setContentBelowTable(parsedData.contentBelowTable);
  }

  if (parsedData.doctorInfo) {
    setDoctorInfo(parsedData.doctorInfo);
  }

  if (parsedData.tableData && Array.isArray(parsedData.tableData)) {
    console.log("  ✅ Setting table data from JSON");
    setTableData(parsedData.tableData);
  } else if (Array.isArray(parsedData)) {
    setTableData(parsedData);
  }
} catch (error) {
  console.error("  ❌ Error parsing JSON longdesc:", error);
}
    }
  } else {
    // No existing data - initialize with empty template
    console.log("  - No longdesc, initializing with empty template");
    setTableData(
      Array(4).fill(null).map((_, index) => ({
        id: index,
        date: '',
        day: '',
        rightOvary: '',
        leftOvary: '',
        endometrialThickness: '',
        pouchOfDouglas: ''
      }))
    );
  }
}, [props.selectedProcedure?.longdesc, org]); // Include org in dependencies

// 4. ADDITIONAL FIX: Add a debug useEffect to monitor tableData changes
useEffect(() => {
  console.log("📊 Table data changed:", {
    rowCount: tableData.length,
    hasData: tableData.some(row => 
      Object.values(row).some(val => val && val !== '')
    ),
    firstRow: tableData[0]
  });
}, [tableData]);






useEffect(() => {
  if (!activeQuill) return;
  const quill = activeQuill.getEditor();
  
  const updateFormats = () => {
    if (!quill) return;
    const range = quill.getSelection();
    if (range) {
      setCurrentFormats(quill.getFormat(range));
    }
  };

  quill.on('selection-change', updateFormats);
  quill.on('text-change', updateFormats);

  updateFormats(); // Initial call

  // Cleanup listeners on editor or activeQuill change
  return () => {
    quill.off('selection-change', updateFormats);
    quill.off('text-change', updateFormats);
  };
}, [activeQuill]);



const handleCellChange = (rowIndex, field, value) => {
  console.log(`📝 Cell changed: row=${rowIndex}, field=${field}, valueLength=${value?.length || 0}`);
  
  setTableData(prevData => {
    const newData = [...prevData];
    if (newData[rowIndex]) {
      newData[rowIndex] = {
        ...newData[rowIndex],
        [field]: value
      };
    }
    return newData;
  });
};
  const handleHeaderClick = (headerId) => {
    setEditingHeader(headerId);
  };

  const handleHeaderSave = (headerId, newText) => {
    const newHeaders = headers.map(header =>
      header.id === headerId
        ? { ...header, text: newText }
        : header
    );
    setHeaders(newHeaders);
    setEditingHeader(null);
  };

  // Edit procedure function
  const editProcedure = (procedure) => {
    dispatch(
      patientActions.editProcedure(procedure, rescb => {
        console.log("Procedure edited successfully:", rescb);
        if (rescb && rescb.successMessages) {
          console.log("Procedure edited successfully:", rescb);
          props.closeModal({
            success:"FOLLICULAR STUDY CYCLE report updated  successfully",
          });
        } else {
          console.error("Error editing procedure:", rescb);
        }
      })
    );
  };

  // Save procedure function
  const saveProcedure = (procedure) => {
    let new_procedure = {
      patientId: procedure.patientId,
      visitId: procedure.visitId,
      templateId: procedure.templateId,
      groupname: "ULTRASOUND",
      subgroup: RADIOLOGYREPORT,
      templateId: "FOLLICULAR STUDY CYCLE",
      longdesc: procedure.longdesc,
      notes: "Follicular Study Cycle Report",
      billNumber: props.selectedProcedure.billNumber,
      markForDel: procedure.markForDel,
      billable: false,
      packageService: props.selectedProcedure?.packageService ? props.selectedProcedure.packageService : null
    };
    if (new_procedure.packageService && new_procedure.billable) {
      new_procedure.packageService.billable = false;
    }
    console.log("New Procedure to be saved:", new_procedure);

    dispatch(
      patientActions.insertToProcedure(new_procedure, rescb => {
        console.log("Procedure added successfully:", rescb);
        if (rescb && rescb.successMessages) {
          console.log("Procedure added successfully:", rescb);
        } else {
          console.error("Error adding procedure:", rescb);
        }
      })
    );
  };

  // Handle save function
  // const handleSave = () => {
  //   const htmlData = convertToHTML();
  //   console.log('Follicular monitoring data saved as HTML:', htmlData);

  //   let updatedProcedure = props.selectedProcedure;
  //   if (props.selectedProcedure && props.selectedProcedure.longdesc) {
  //     updatedProcedure.groupname = "ULTRASOUND";
  //     updatedProcedure.subgroup = RADIOLOGYREPORT;
  //     console.log("Updating existing procedure with new data");
  //     updatedProcedure.longdesc = htmlData;
  //     editProcedure(updatedProcedure);
  //     props.closeModal({
  //       success: updatedProcedure.templateId + " report updated  successfully",
  //     });
  //   } else {
  //     if (updatedProcedure) {
  //       console.log("Creating new procedure with data");
  //       updatedProcedure.longdesc = htmlData;
  //       updatedProcedure.groupname = "ULTRASOUND";
  //       console.log("Updated Procedure:", updatedProcedure);
  //       editProcedure(updatedProcedure);
  //       saveProcedure(updatedProcedure);
  //     } else {
  //       let new_procedure = {
  //         patientId: props.patientInfo.id,
  //         visitId: props.patientInfo.visit.id,
  //         groupname: "ULTRASOUND",
  //         subgroup: RADIOLOGYREPORT,
  //         templateId: "FOLLICULAR STUDY CYCLE",
  //         longdesc: htmlData,
  //         notes: "Follicular Study Cycle Report",
  //         billNumber: props.selectedProcedure.billNumber,
  //         markForDel: false,
  //         billable: false,
  //       };
  //       saveProcedure(new_procedure);
  //     }
  //   }
  // };

const handleSave = () => {
  console.log("💾 Saving follicular data...");
  console.log("  - Table rows:", tableData.length);
  console.log("  - Has data:", tableData.some(row => 
    Object.values(row).some(val => val && val !== '')
  ));
  
  const htmlData = convertToHTML();
  console.log("  - Generated HTML length:", htmlData.length);

  let updatedProcedure = props.selectedProcedure;
  
  if (props.selectedProcedure && props.selectedProcedure.longdesc) {
    updatedProcedure.groupname = "ULTRASOUND";
    updatedProcedure.subgroup = RADIOLOGYREPORT;
    updatedProcedure.longdesc = htmlData;
    console.log("  - Updating existing procedure");
    editProcedure(updatedProcedure);
    props.closeModal({
      success: updatedProcedure.templateId + " report updated successfully",
    });
  } else {
    if (updatedProcedure) {
      updatedProcedure.longdesc = htmlData;
      updatedProcedure.groupname = "ULTRASOUND";
      console.log("  - Creating new procedure");
      editProcedure(updatedProcedure);
      saveProcedure(updatedProcedure);
    } else {
      let new_procedure = {
        patientId: props.patientInfo.id,
        visitId: props.patientInfo.visit.id,
        groupname: "ULTRASOUND",
        subgroup: RADIOLOGYREPORT,
        templateId: "FOLLICULAR STUDY CYCLE",
        longdesc: htmlData,
        notes: "Follicular Study Cycle Report",
        billNumber: props.selectedProcedure.billNumber,
        markForDel: false,
        billable: false,
      };
      console.log("  - Saving new procedure");
      saveProcedure(new_procedure);
    }
  }
};


  // Quill ref management
  const setQuillRef = (key, ref) => {
    quillRefs.current[key] = ref;
  };

  const handleFocus = (key) => {
    setActiveQuill(quillRefs.current[key]);
  };

  // Toolbar handlers - apply to active editor
  const handleFormat = (format) => {
    if (!activeQuill) return;
    
    const quill = activeQuill.getEditor();
    const range = quill.getSelection();
    
    if (range) {
      if (format === 'bold' || format === 'italic' || format === 'underline') {
        const current = quill.getFormat(range);
        quill.format(format, !current[format]);
      } else if (format === 'list-ordered') {
        quill.format('list', 'ordered');
      } else if (format === 'list-bullet') {
        quill.format('list', 'bullet');
      }
    }
  };

  // Print handler
  const handlePrint = () => {
    try {
      // Get the patient info from props
      const patient = props.patientInfo || props.patientData?.[0] || {};
      const person = patient.person || {};

      // Create procedure data with all required fields
      const procedureData = {
        patientId: patient.patientId || patient.id,
        visitId: patient.visitId,
        templateId: "FOLLICULAR STUDY CYCLE",
        subgroup: RADIOLOGYREPORT,
        longdesc: convertToHTML(),
        notes: "Follicular Study Cycle Report",
        packageService: {
          name: "FOLLICULAR STUDY CYCLE",
          description: "Follicular Study Cycle",
        },
        // Include any other required fields from ProcedureListing.js
        procedureslist: [{
          ...props.selectedProcedure,
          longdesc: convertToHTML()
        }]
      };

      setPrintData({
        selectedPatient: {
          ...patient,
          id: patient.patientId || patient.id,
          fullName: patient.fullName || `${person.firstName || ''} ${person.lastName || ''}`.trim(),
          age: patient.age || person.age
        },
        templateId: "FOLLICULAR STUDY CYCLE",
        patientData: procedureData
      });
    } catch (error) {
      console.error("Print preparation error:", error);
    }
  };

  return (
    <Container maxWidth="lg" className={classes.root}>
      <Typography variant="h4" className={classes.header}>
        FOLLICULAR STUDY CYCLE
      </Typography>

      {/* Unified Toolbar */}
      <Box className={classes.formatToolbar}>
        <IconButton onClick={() => handleFormat('bold')} aria-label="bold" className={currentFormats.bold ? 'active' : ''} >
          <FormatBoldIcon />
        </IconButton>
        <IconButton onClick={() => handleFormat('italic')} aria-label="italic"  className={currentFormats.italic ? 'active' : ''} >
          <FormatItalicIcon />
        </IconButton>
        <IconButton onClick={() => handleFormat('underline')} aria-label="underline" className={currentFormats.underline ? 'active' : ''} >
          <FormatUnderlinedIcon />
        </IconButton>
        <IconButton onClick={() => handleFormat('list-ordered')} aria-label="ordered list" className={currentFormats.list === 'ordered' ? 'active' : ''}>
          <FormatListNumberedIcon />
        </IconButton>
        <IconButton onClick={() => handleFormat('list-bullet')} aria-label="bullet list" className={currentFormats.list === 'bullet' ? 'active' : ''} >
          <FormatListBulletedIcon />
        </IconButton>
      </Box>

     <Box display="flex" gap={4} className={classes.contentSection}>
  <Box flex={1}>
    <ReactQuill
      ref={ref => setQuillRef('uterus', ref)}
      value={uterus}
      onChange={setUterus}
      theme="snow"
      modules={modules}
      formats={formats}
      onFocus={() => handleFocus('uterus')}
    />
  </Box>

  <Box flex={1}>
    <ReactQuill
      ref={ref => setQuillRef('lmp', ref)}
      value={lmp}
      onChange={setLmp}
      theme="snow"
      modules={modules}
      formats={formats}
      onFocus={() => handleFocus('lmp')}
    />
  </Box>
</Box>

      {/* Main Table */}
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <TableCell key={header.id} onClick={() => handleHeaderClick(header.id)}>
                {editingHeader === header.id ? (
                  <TextField
                    defaultValue={header.text}
                    className={classes.headerEditField}
                    onBlur={(e) => handleHeaderSave(header.id, e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleHeaderSave(header.id, e.target.value);
                      }
                    }}
                    autoFocus
                    fullWidth
                    variant="standard"
                  />
                ) : (
                  header.text
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData.map((row, rowIndex) => (
            <TableRow key={row.id}>
              {headers.map((header) => (
                <TableCell key={header.id}>
                  <ReactQuill
                    ref={ref => setQuillRef(`${rowIndex}-${header.id}`, ref)}
                    value={row[header.id] || ''}
                    onChange={(value) => handleCellChange(rowIndex, header.id, value)}
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    onFocus={() => handleFocus(`${rowIndex}-${header.id}`)}
                   // placeholder={`Enter ${header.text.toLowerCase()}...`}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Content Below Table */}
      <Box className={classes.contentSection}>
        {/* <Typography variant="subtitle2" className={classes.sectionTitle}>
          Impression & Recommendations
        </Typography> */}
        <ReactQuill
          ref={ref => setQuillRef('contentBelow', ref)}
          value={contentBelowTable}
          onChange={setContentBelowTable}
          theme="snow"
          modules={modules}
          formats={formats}
          onFocus={() => handleFocus('contentBelow')}
         // placeholder="Enter impression and recommendations..."
        />
       
      </Box>




      {/* Doctor Information */}
      <Box className={classes.doctorInfoContainer}>
        {/* <Typography variant="subtitle2" className={classes.sectionTitle}>
          Radiologist Information
        </Typography> */}
        <ReactQuill
          ref={ref => setQuillRef('doctorInfo', ref)}
          value={doctorInfo}
          onChange={setDoctorInfo}
          theme="snow"
          modules={modules}
          formats={formats}
          onFocus={() => handleFocus('doctorInfo')}
          //placeholder="Enter radiologist information..."
        />
      </Box>

      {/* Action Buttons */}
      <Box className={classes.buttonContainer}>
        <Button
          variant="contained"
          color="primary"
          
          onClick={handleSave}
          size="large"
          style={{ marginRight: '16px' }}
        >
          Save 
        </Button>
       
      </Box>

      {/* Print Component */}
      {printData && (
        <div style={{ display: 'none' }}>
          <Components.RadiologyPrint
            doctorInfo={doctorInfo}
            patientData={printData.patientData}
            templateId={printData.templateId}
            selectedPatient={printData.selectedPatient}
          />
        </div>
      )}
    </Container>
  );
};

export default Follicular;